<div *ngIf="form">
  <ssg-checkbox-list *ngIf="valueType === 'booleanList'"
  [name]="key"
  [dataList]="items"
  [systemName]="systemName"
  [category]="category"
  textFieldName="Name"
  valueFieldName="Id"
  (valueChange)="changed($event , null)"
  [group]="form"
  class="cheked">
</ssg-checkbox-list>
<div *ngFor="let item of items">
    <div  [ngSwitch]="valueType">
        <ssg-input *ngSwitchCase="'number'"  
                        [name]="this.key"
                        [group]="form"
                        (valueChange)="changed($event,item)"
                        [withComma]="false"
                        textType="number"
                        [label]="item.Name">
        </ssg-input>
        <ssg-input *ngSwitchCase="'text'"  
                     [name]="this.key"
                     [group]="form"
                     (valueChange)="changed($event,item)"
                     textType="text"
                     [label]="item.Name">
        </ssg-input>
        <ssg-checkbox *ngSwitchCase="'boolean'"
                        [group]="form"
                        [name]="this.key"
                        (valueChange)="changed($event,item)"
                        [label]="item.Name">
        </ssg-checkbox>

        <ssg-select *ngSwitchCase="'array'"
                    [name]="this.key"
                    [group]="form"
                    [label]="item.Name"
                    [apiName]="apiName"
                    [systemName]="systemName"
                    [category]="category"
                    (valueChange)="changed($event,item)"
                    [textFieldName]="textFieldName"
                    [valueFieldName]="valueFieldName">
        </ssg-select>
    </div>
  </div>
</div>
